<div class="root-div">
  <button
    #copyButton
    type="button"
    pButton
    pRipple
    (click)="onCopyClick($event)"
    pTooltip="Copy Item"
    tooltipPosition="bottom"
    class="p-button-text p-button-plain p-button-lg tool-bar-pbutton icon-top-space-toolbar icon-right-space-toolbar icon-left-space-toolbar">
    <mat-icon ripple>content_copy</mat-icon>
  </button>
</div>
